<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav position="end" [opened]="false" class="sidebar">
        <mat-sidenav-content class="sidenav-content">

            <div class="sidenav-content-header">
                <h2>Cargar Saldo</h2>
                <button mat-icon-button (click)="sidenav.close()" class="close-icon">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

            <div class="sidenav-content-body">
                <div class="sidenav-content-body-text">Saldo disponible</div>
                <div class="sidenav-content-body-balance">{{ balance | currency }}</div>
            </div>

            <div class="method-selection">
                <div class="method-title">Elegí cómo querés cargar saldo</div>

                <div class="method-card" (click)="selectCard()">
                    <div class="method-card-icon card-icon">
                        <mat-icon>credit_card</mat-icon>
                    </div>
                    <div class="method-card-info">
                        <div class="method-card-title">Tarjeta</div>
                        <div class="method-card-subtitle">Pagá con débito o DEBIN</div>
                        <div class="method-card-badge">Tiene un costo de {{plusPagosCommission}}%</div>
                    </div>
                    <mat-icon class="method-card-arrow">chevron_right</mat-icon>
                </div>

                <div class="method-card" (click)="selectTransfer()">
                    <div class="method-card-icon transfer-icon">
                        <mat-icon>account_balance</mat-icon>
                    </div>
                    <div class="method-card-info">
                        <div class="method-card-title">Transferencia</div>
                        <div class="method-card-subtitle">Transferí desde tu banco o billetera virtual.</div>
                        <div class="method-card-badge">Tiene un costo de {{benkoCommission}}%</div>
                    </div>
                    <mat-icon class="method-card-arrow">chevron_right</mat-icon>
                </div>
            </div>

        </mat-sidenav-content>
    </mat-sidenav>
</mat-sidenav-container>
